document.addEventListener('DOMContentLoaded', () => {
  const productPage = document.querySelector('[data-product-page]');
  if (productPage) {
    const galleryButtons = [...productPage.querySelectorAll('[data-gallery-image]')];
    const variantSelect = productPage.querySelector('[data-variant-select]');
    const price = productPage.querySelector('[data-product-price]');
    const comparePrice = productPage.querySelector('[data-product-compare]');
    const addButton = productPage.querySelector('[data-add-to-cart]');

    galleryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        galleryButtons.forEach((item) => item.setAttribute('aria-current', String(item === button)));
      });
    });

    productPage.querySelectorAll('[data-fit-jump]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const panel = productPage.querySelector(link.getAttribute('href'));
        if (!panel) return;
        event.preventDefault();
        panel.open = true;
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    const feedbackPanel = document.querySelector('.ff-product-feedback__dropdown');
    const feedbackJump = productPage.querySelector('[data-product-feedback-jump]');
    if (feedbackPanel && feedbackJump) {
      feedbackJump.hidden = false;
      feedbackJump.setAttribute('href', `#${feedbackPanel.id}`);
      const feedbackHeading = feedbackPanel.querySelector('summary');
      const feedbackLabel = feedbackHeading ? feedbackHeading.textContent.replace(/\s+/g, ' ').trim() : '';
      if (feedbackLabel) feedbackJump.textContent = feedbackLabel;
      feedbackJump.addEventListener('click', (event) => {
        event.preventDefault();
        feedbackPanel.open = true;
        feedbackPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    const watchDemo = productPage.querySelector('[data-watch-demo]');
    if (watchDemo) {
      watchDemo.addEventListener('click', (event) => {
        event.preventDefault();
        const demos = productPage.querySelector('[data-product-demos]');
        const video = demos?.querySelector('video');
        demos?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (video) {
          video.muted = true;
          video.play().catch(() => {});
        }
      });
    }

    productPage.querySelectorAll('[data-qty]').forEach((control) => {
      const input = control.querySelector('input[name="quantity"]');
      if (!input) return;
      control.querySelectorAll('[data-qty-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const step = Number(button.dataset.qtyStep) || 0;
          const next = Math.max(1, (Number(input.value) || 1) + step);
          input.value = String(next);
        });
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (!option) return;
        if (price) price.textContent = option.dataset.price || '';
        if (comparePrice) {
          comparePrice.textContent = option.dataset.comparePrice || '';
          comparePrice.hidden = !option.dataset.comparePrice;
        }
        const available = option.dataset.available === 'true';
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? 'Add to bag' : 'Sold out';
        }
        const backInStock = productPage.querySelector('[data-back-in-stock]');
        const backInStockVariant = productPage.querySelector('[data-back-in-stock-variant]');
        if (backInStock) backInStock.hidden = available;
        if (backInStockVariant) backInStockVariant.value = option.value;
        if (option.dataset.image) {
          const matchingThumb = galleryButtons.find((button) => button.dataset.image === option.dataset.image);
          if (matchingThumb) matchingThumb.click();
        }
      });
    }

    const picker = productPage.querySelector('[data-variant-picker]');
    if (picker && variantSelect) {
      const selectedOptions = {};
      const sizeFieldset = picker.querySelector('.ff-variant-picker__option--size');
      const sizeIndex = picker.getAttribute('data-size-option-index')
        || (sizeFieldset ? sizeFieldset.getAttribute('data-option-index') : null);
      picker.querySelectorAll('[data-option-value][aria-pressed="true"]').forEach((button) => {
        selectedOptions[button.dataset.optionIndex] = button.dataset.value;
      });

      const variantMatches = (option, trial) => {
        if (option.dataset.available !== 'true') return false;
        return Object.keys(trial).every((key) => option.getAttribute(`data-option-${key}`) === trial[key]);
      };

      const refreshAvailability = () => {
        picker.querySelectorAll('[data-option-value]').forEach((button) => {
          const index = button.dataset.optionIndex;
          const trial = {};
          Object.keys(selectedOptions).forEach((key) => {
            if (key === index) return;
            if (sizeIndex != null && key === sizeIndex && index !== sizeIndex) return;
            trial[key] = selectedOptions[key];
          });
          trial[index] = button.dataset.value;
          const available = [...variantSelect.options].some((option) => variantMatches(option, trial));
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
          button.classList.toggle('is-unavailable', !available);
        });
      };

      const requireCompleteSelection = () => {
        if (!addButton) return;
        addButton.disabled = true;
        addButton.textContent = 'Select an available option';
      };

      refreshAvailability();
      picker.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.getAttribute('aria-disabled') === 'true') return;
          const index = button.dataset.optionIndex;
          selectedOptions[index] = button.dataset.value;
          const fieldset = button.closest('fieldset');
          fieldset?.querySelectorAll('[data-option-value]').forEach((peer) => {
            peer.setAttribute('aria-pressed', String(peer === button));
          });
          const label = fieldset?.querySelector('[data-option-label]');
          if (label) label.textContent = button.dataset.label || button.dataset.value;
          refreshAvailability();

          const clickedSize = sizeIndex != null && index === sizeIndex;
          if (!clickedSize && sizeIndex != null && selectedOptions[sizeIndex]) {
            const sizeButton = [...picker.querySelectorAll(`[data-option-value][data-option-index="${sizeIndex}"]`)]
              .find((el) => el.dataset.value === selectedOptions[sizeIndex]);
            if (sizeButton && sizeButton.getAttribute('aria-disabled') === 'true') {
              delete selectedOptions[sizeIndex];
              const sizeGroup = sizeButton.closest('fieldset');
              sizeGroup?.querySelectorAll('[data-option-value]').forEach((peer) => {
                peer.setAttribute('aria-pressed', 'false');
              });
              const sizeLabel = sizeGroup?.querySelector('[data-option-label]');
              if (sizeLabel) sizeLabel.textContent = sizeGroup?.dataset.sizePrompt || 'Choose your size';
              refreshAvailability();
              requireCompleteSelection();
              return;
            }
          }

          const optionCount = picker.querySelectorAll('fieldset[data-option-index]').length;
          if (Object.keys(selectedOptions).length < optionCount) {
            requireCompleteSelection();
            return;
          }
          const match = [...variantSelect.options].find((option) => variantMatches(option, selectedOptions));
          if (!match) {
            requireCompleteSelection();
            return;
          }
          variantSelect.value = match.value;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      const initialOption = variantSelect.selectedOptions[0];
      const initialLabel = `${initialOption?.getAttribute('data-options') || ''} ${initialOption?.textContent || ''}`;
      const syncInitialImage = productPage.dataset.productHandle === 'liftbowl-food-water-station'
        || productPage.dataset.productHandle === 'rearrealm-rear-seat-dog-cover'
        || /without ribbon/i.test(initialLabel);
      if (initialOption?.dataset.image && syncInitialImage) {
        const matchingThumb = galleryButtons.find((button) => button.dataset.image === initialOption.dataset.image);
        if (matchingThumb) matchingThumb.click();
      }
    }

    const giftToggle = productPage.querySelector('[data-gift-recipient-toggle]');
    const giftFlag = productPage.querySelector('[data-gift-recipient-flag]');
    const giftHint = productPage.querySelector('[data-gift-recipient-hint]');
    const giftFieldsWrap = productPage.querySelector('[data-gift-recipient-fields]');
    const giftFields = [...productPage.querySelectorAll('[data-gift-recipient-field]')];
    const giftEmail = productPage.querySelector('[data-gift-recipient-email]');
    const syncGiftRecipient = () => {
      const on = giftToggle?.value === 'recipient';
      if (giftFlag) giftFlag.disabled = !on;
      if (giftHint) giftHint.hidden = !on;
      if (giftFieldsWrap) giftFieldsWrap.hidden = !on;
      giftFields.forEach((field) => {
        field.disabled = !on;
      });
      if (giftEmail) giftEmail.required = on;
    };
    if (giftToggle) {
      giftToggle.addEventListener('change', syncGiftRecipient);
      syncGiftRecipient();
    }
  }
});
